import React from 'react';
import { api } from '../../../api';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { message, Input, Modal } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { withRouter } from "react-router-dom";
import '../styles.scss';

const FormItem = Form.Item;
class NormalLoginForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            disabledLogin: false,
            visibleCodigo: false
        }
    }
    componentDidMount() {
        if (this.props.mail) {
            this.props.form.setFieldsValue({
                mail: this.props.mail
            })
        }
    }
    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const response = await api.auth.changePass({ ...values });
                if (response.status === "success") {
                    message.success(response.message, 5);
                    this.props.closeModal()
                } else {
                    message.error(response.message, 7);
                    this.setState({ disabledLogin: false });
                }
                try {

                } catch (e) {
                    message.error("Verifique su conexión a internet", 7);
                    this.setState({ disabledLogin: false });
                }
            }
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form,
            layout = {
                labelCol: { xs: { span: 6 }, sm: { span: 6 }, },
                wrapperCol: { xs: { span: 18 }, sm: { span: 18 }, },
            };
        return (
            <Modal
                visible={true}
                closeIcon={null}
                onCancel={this.props.closeModal}
                cancelText="Cancelar"
                okText="Grabar"
                onOk={this.handleSubmit}
            >
                <Form onSubmit={this.handleSubmit} className="form-v1">
                    <FormItem {...layout} label="Mail">
                        {getFieldDecorator('mail', {
                            rules: [{ required: true, message: 'Por favor ingrese su nombre de usuario!' }],
                        })(
                            <Input prefix={<UserOutlined />} placeholder="MAIL" maxLength={50} />
                        )}
                    </FormItem>
                    <FormItem {...layout} label="Documento">
                        {getFieldDecorator('documento', {
                            rules: [{ required: true, message: 'Por favor ingrese su nombre de usuario!' }],
                        })(
                            <Input prefix={<UserOutlined />} placeholder="MAIL" maxLength={13}/>
                        )}
                    </FormItem>
                    <FormItem {...layout} label="Nueva clave">
                        {getFieldDecorator('newclave', {
                            rules: [{ required: true, message: 'Por favor ingrese su contraseña!' }],
                        })(
                            <Input prefix={<LockOutlined />} placeholder="DOCUMENTO" maxLength={50} />
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const WrappedNormalLoginForm = Form.create()(withRouter(NormalLoginForm));

export default WrappedNormalLoginForm;
